<template>
  <div class="reports">
    <ReportListsWinloseComponent
      :ref-key-text="refKeyText"
      :title="title"
      :url-path="urlPath"
      :route-name="routeName"
    />
  </div>
</template>

<script>
import ReportListsWinloseComponent from '@/components/ReportListsWinloseComponent.vue'

export default {
  components: {
    ReportListsWinloseComponent,
  },
  data() {
    return {
      refKeyText: 'Match',
      title: 'W/L Match (Simple)',
      urlPath: '/reports/v2/match_winlose_lists',
      routeName: 'reports-match-winlose-lists',
    }
  },
}
</script>

<style>

</style>
